import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ComingSoonBadge } from '~/pages/NewOverview/BigNumbers/components/Card/styles';
import {
  CollapseContainer,
  CollapseContent,
  CollapseHeader,
  CollapseIcon,
  CollapseTitle,
} from './styles';

interface CollapseProps {
  title: string;
  children: React.ReactNode;
  comingSoon?: boolean
}

export const Collapse = ({ title, children, comingSoon }: Readonly<CollapseProps>) => {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  return (
    <CollapseContainer>
      <CollapseHeader onClick={() => setIsOpen((p) => !p)}>
        <CollapseTitle>{title}</CollapseTitle>
        <CollapseIcon $isopen={isOpen} />
        {comingSoon && (
          <ComingSoonBadge>
            {t('emBreve')}
          </ComingSoonBadge>
        )}
      </CollapseHeader>
      <CollapseContent $isopen={isOpen} style={comingSoon ? { opacity: 0.8, filter: 'blur(2px)' } : undefined}>
        {children}
      </CollapseContent>
    </CollapseContainer>
  );
};
